import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

const PublicLayout: React.FC<RouteComponentProps> = ({ children }) => <>{children}</>;

export default withRouter(PublicLayout);
